var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDuoLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.585 18.01 5.575 12l6.01-6.01L13 7.404l-4.6 4.6 4.6 4.6-1.414 1.406h-.001Zm5.425 0L10.999 12l6.011-6.01 1.414 1.414-4.6 4.6 4.6 4.6-1.413 1.406h-.001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDuoLeft);
export default __webpack_public_path__ + "static/media/chevron_duo_left.2fe8f495cb87b3457a7b4f6d57051325.svg";
export { ForwardRef as ReactComponent };